//
import PosCustomerReceivablePaymentModel from '@/models/POS/PosCustomerReceivablePayment'

/**
 * 
 */
export default class PosCustomerReceivablePayment {

  /**
   * 
   */
  static delete(customerReceivablePayment) {
    return customerReceivablePayment.delete()
  }

  /**
   * 
   */
  static model() {
    return PosCustomerReceivablePaymentModel
  }

  /**
   * 
   */
  static toList() {
    return class extends PosCustomerReceivablePaymentModel {
      static includes = [
        'g_user.hr_employee',
        'pos_cash_desk.g_branch_office',
        'sl_customer',
      ]
    }
  }
}